export const DRAWER_WIDTH = 240

export const SHOW_DEBUG_BOXES = false

export const APP_TITLE = 'Attendix'
